export default __webpack_public_path__ + "static/media/avatar-mock.61c1ba7e.png";